import _ from 'lodash'
import Enum from 'enum'
import { Link } from 'react-router'

const SEGMENT_DESCRIPTION_PREFIX = "This chat is available to "

export const Audiences = new Enum({
  EVERYONE: {
    display: 'Everyone',
    long: 'This chat is available to everyone who visits your website.'
  },
  USERS: {
    display: 'Known Users',
    long: 'This chat is available to known users who visit your website.'
  },
  SEGMENT: {
    display: 'Choose a Segment',
    long: 'This chat is available to SEGMENT who visit your website.'
  }
})

export function audienceSummary(orgSettings, segments) {
  const { audience } = orgSettings.theme
  const userListIds = orgSettings.theme.userListIds.toSet()

  if (!audience) {
    return
  }

  if (audience === Audiences.SEGMENT.key && userListIds.size > 0) {
    const selectedSegments = _.filter(segments, (segment) => userListIds.includes(segment.id))

    if (selectedSegments.length > 0) {
      const segmentLinks = _.flatten(_.map(selectedSegments, (segment) => (
        [
          <span>, </span>,
          <Link to={`/contacts/segments/${segment.id}`}>
            {segment.name}
          </Link>
        ]
      ))).slice(1)

      return (
        <span>{SEGMENT_DESCRIPTION_PREFIX} {segmentLinks}</span>
      )
    }
  } else if (Audiences[audience]) {
    return Audiences[audience].value.long
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Audience/Helpers.js